import { QUERY_PARAMS } from 'bdvp-common/src/utils/constants';

const toggleFiltersParam = (open, history) => {

    const urlParams = new URLSearchParams(history.location.search);
    const { openFilters } = QUERY_PARAMS;
    open ? urlParams.set(openFilters, '1') : urlParams.delete(openFilters);

    history.replace({
        search: urlParams.toString(),
    });

};

export default toggleFiltersParam;
